import type { IInstagramUserProfile } from "../../../../../types/models/instagram-user-profile.models.types";
import type { ISocial } from "../../../../../types/models/social.models.types";
import { useGetHttp } from "../../../http.hook";

interface IResponse {
  instagramUserProfile: IInstagramUserProfile;
  social: ISocial;
}

export function useGetProfileDetailsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/:campaignId/utils/instagram/profile-details",
  });
}
